import * as Yup from "yup";
import { dateToyyyyMMdd } from "../../../../util/date";
import { getPatchOperations } from "../../../../util/form";

export const personAbonnementerForm = (
  personId: string,
  personAbonnementId?: string,
): FormConfig<PersonAbonnementerDTO> => {
  return {
    title: "abonnement",
    lockedValues: [
      {
        id: "personAbonnementId",
        value: personAbonnementId,
      },
      {
        id: "personId",
        value: personId,
      },
    ],
    validationSchema: Yup.object({
      periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
      periodeTilDatoInklusiv: Yup.date().nullable(),
      faktureres: Yup.boolean().required("Faktureres skal være sat"),
      antalEksemplar: Yup.number()
        .required("Antal skal være sat")
        .typeError("Antal kan kun være et tal")
        .integer("Antal kan kun være et positivt heltal")
        .positive("Antal kan kun være et positivt heltal"),
    }),
    form: [
      {
        component: "datepicker",
        id: "periodeFraDato",
        label: "Startdato",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        label: "Slutdato",
        initialValue: "",
      },
      {
        component: "boolean",
        id: "faktureres",
        label: "Faktureres",
        initialValue: false,
        isRequired: true,
      },
      {
        component: "textinput",
        id: "antalEksemplar",
        label: "Antal",
        initialValue: "",
        isRequired: true,
      },
    ],
    get: `person/${personId}/abonnementer/${personAbonnementId}`,
    patch(values: PersonAbonnementerDTO) {
      const ops = getPatchOperations(values);

      return {
        query: `person/${personId}/abonnementer/${personAbonnementId}`,
        body: JSON.stringify(ops),
      };
    },
    post(values: PersonAbonnementerDTO) {
      const {
        periodeFraDato,
        periodeTilDatoInklusiv,
        antalEksemplar,
        faktureres,
      } = values;
      return {
        query: `person/${personId}/abonnementer/`,
        body: {
          abonnementNr: 1,
          periodeFraDato: dateToyyyyMMdd(periodeFraDato),
          periodeTilDatoInklusiv: periodeTilDatoInklusiv
            ? dateToyyyyMMdd(periodeTilDatoInklusiv)
            : "9999-12-31",
          antalEksemplar,
          faktureres,
        },
      };
    },
    delete() {
      return {
        query: `person/${personId}/abonnementer/${personAbonnementId}`,
      };
    },
  };
};
